import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-configuration',
    templateUrl: './breadcrumb.configuration.component.html'
})

export class BreadcrumbConfigurationComponent {
    @Input() companyId: number;
    @Input() facilityId: number;
    @Input() kioskId: number;

    roleMatrix: RoleMatrix;


    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
